export enum CONSOLIDATED_TAB_NAME_ENUM {
  projects = "projects",
  bills = "bills",
  invoices = "invoices",
}
